
<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} {{ $t('tickettemplates') }}</div>
      <div>
        <router-link
          class="btn-blue"
          to="ticket-templates"
        >{{ $t('tickettemplates') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                v-model="ticketDetails.temp_name"
                v-validate="'required'"
                name="template_name"
                id="template_name"
                placeholder="."
                type="text"
              />
              <label
                :class="ticketDetails.temp_name > 0 ? 'shift-up' : '' "
              >{{ $t('templates') }} {{ $t('name') }}</label>
            </div>
            <Tooltip :title="``"  />
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('template_name')"
            >{{ errors.first('template_name') }}</span>
          </p>
        </div>

        <div class="col-md-4 mb-3">
          <div class="d-flex align-items-center">
            <label for="file-selector" class="file-selector w-100">
              <label
                class="file-selector-label"
                :class="ticketDetails.temp_url.length > 0 ? 'shift-up' : ''"
              >{{$t('selectfile')}}</label>
              <span>{{ ticketDetails.temp_url }}</span>
              <input
                type="file"
                v-on:change="uploadImage"
                class="d-none"
                placeholder="Upload logo"
                id="file-selector"
                name="file-selector"
              />
            </label>

            <Tooltip :title="`Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`"  />
          </div>

          <p
            v-if="submitted && ticketDetails.temp_url.length == 0"
            class="error_message"
          >{{$t('selectafile')}}</p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t('active') }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_active"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="OnFinalSubmit(true)" class="btn-blue">{{ $t('save') }}</button>
          <button
            @click.prevent.stop="OnFinalSubmit(false)"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>
          <button @click.prevent.stop="OnReset()" class="btn-black">{{ $t('reset') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="ticket-templates"
          >{{ $t('cancel') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";

export default {
  data() {
    return {
      submitted: false,
      ticketDetails: {
        temp_name: "",
        temp_url: "",
        temp_active: "Y"
      }
    };
  },
  beforeMount() {
    this.OnReset();
  },

  methods: {
    OnReset: function() {
      this.ticketDetails = {
        temp_name: "",
        temp_url: "",
        temp_active: "Y"
      };
    },

    uploadImage: function(event) {
      let ext = ".ejs";
      this.ticketDetails.temp_url = event.target.files[0].name.match(ext);
      if (!this.ticketDetails.temp_url) {
        this.$toasted.show("Please Select Only .ejs File");
        event.target.value = "";
      } else {
        this.ticketDetails.temp_url = event.target.files[0].name;
        event.target.value = "";
        this.$forceUpdate();
      }
      // let self = this;
      // let formData = new FormData();
      // formData.append("file", event.target.files[0]);
      // formData.append("filePath", "/uploads/users/");
      // MasterService.GlobalUploadImage(formData)
      //   .then(response => {
      //     const { data } = response;
      //     data.message ? this.$toasted.show(data.message) : "";
      //     if (data.status) {
      //       self.userDetails.user_profile_image_url = data.path;
      //     }
      //     self.BaseURL = data.BaseURL;
      //   })
      //   .catch(this._CatchError);
    },

    OnFinalSubmit: function(flag) {
      this.submitted = true;

      this.$validator.validate().then(valid => {
        if (this.ticketDetails.temp_url.length == 0) {
          return;
        }
        if (valid) {
          MasterService.AddTicketTemplate(this.ticketDetails)
            .then(response => {
              const { data } = response;

              if (data.status) {
                this.OnReset();
                this.$toasted.show(data.message);

                if (flag) {
                  this.$router.push({
                    path: "/master/ticket-templates"
                  });
                } else {
                  this.submitted = false;
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    }
  }
};
</script>

<style scoped>
.w-62 {
  width: 62%;
}

.h20 {
  height: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/TicketTemplates/addTicketTemplates.vue